import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import {reconciliationData} from '../reconciliation-items'

import { updateNestedValue } from "../../../../../../common/services/common.service";
import { reconciliationItems } from "../../../../../../redux/settlement-hub/reconciliation-items/action";
import { selectReconciliationItemCreatedItem, selectReconciliationItemDeletedItem, selectReconciliationItemsListItems, selectReconciliationItemUpdatedItem } from "../../../../../../redux/settlement-hub/reconciliation-items/selector";
import { ReconciliationItemPopup } from "../components/reconciliation-item-popup.component";
import { libraryData } from "../../constants/constants";

const ReconciliationItems = ({
  selectedReconciliationRequest
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showReconciliationItemPopup, setShowReconciliationItemPopup] = useState<boolean>(false);
  const [selectedReconciliationItem, setSelectedReconciliationItem] = useState<any>({
    "settlement_ref_no": 0,
    "payment_id": 0,
    "status": "",
    "amount": 0,
    "comission": 0,
    "withholding_amount": 0,
    "tcs": 0,
    "tds": 0,
  });  

  const [listItems, setListItems] = useState<any>([]);
  const listOfReconciliationItemsData = useSelector(selectReconciliationItemsListItems)
  const createReconciliationItemsData = useSelector(selectReconciliationItemCreatedItem)
  const editReconciliationItemsData = useSelector(selectReconciliationItemUpdatedItem)
  const deleteReconciliationsItemData = useSelector(selectReconciliationItemDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'SettlementRefNo', headerName: 'Settlement Ref No', sortable: true, filter: true, filterType: 'text', },
      { field: 'PaymentId', headerName: 'Payment Id', sortable: true, filter: true, filterType: 'text', },
      { field: 'Amount.Value', headerName: 'Amount', sortable: true, filter: true, filterType: 'number', },
      { field: 'Comission.Value', headerName: 'comission', sortable: true, filter: true, filterType: 'number', },
      { field: 'WithholdingAmount.Value', headerName: 'Withholding Amount', sortable: true, filter: true, filterType: 'number', },
      { field: 'TCS.Value', headerName: 'TCS', sortable: true, filter: true, filterType: 'number', },
      { field: 'TDS.Value', headerName: 'TDS', sortable: true, filter: true, filterType: 'number', },
      { field: 'ReconciliationItemStatusId', headerName: 'Status', sortable: true, filter: true, filterType: 'text', cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData, menuKey: 'Value', menuValue: 'Description', callback: handleStatus, anchorPosition: 'top-left' },
      },
      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'UpdatedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
    ]);
  }

  const handleStatus = () => {

  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedReconciliationItem, path, value', selectedReconciliationItem, path, value)
    const updatedData = updateNestedValue(selectedReconciliationItem, path, value)

    console.log('updatedData', updatedData)
    setSelectedReconciliationItem({...updatedData});
  }

  const handleAdd = () => {   
    setSelectedReconciliationItem({
      "settlement_ref_no": 0,
      "payment_id": 0,
      "status": "",
      "amount": 0,
      "comission": 0,
      "withholding_amount": 0,
      "tcs": 0,
      "tds": 0,
      })
    setShowReconciliationItemPopup(true)
  }

  const handleEdit = (data: any) => {
    console.log('Edit item data', data)
    setSelectedReconciliationItem({
      "settlement_ref_no": data.settlement_ref_no,
      "payment_id": data.payment_id,
      "status":  data.status,
      "amount":  data.amount.value,
      "comission":  data.comission.value,
      "withholding_amount":  data.withholding_amount.value,
      "tcs":  data.tcs.value,
      "tds":  data.tds.value,
      })
    setShowReconciliationItemPopup(true)
  }

  const handleDelete = async (data: any) => {
    console.log('delete item', data)
    await dispatch(reconciliationItems.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-items/delete`,
      entity: 'reconciliationItems',
      jsonData: {
        Context:{},
        Records: [{Id: data?.ReconciliationRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Reconciliation Item</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Initiate Reconciliation',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    listReconciliationRequestItems();
  }

  const listReconciliationRequestItems = async () => {
    console.log('reconciliationItems')
    await dispatch(reconciliationItems.resetAction({actionType:'list'}))
    await dispatch(reconciliationItems.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-items/list`,
      entity: 'reconciliationItems',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSaveReconciliationItem = async (selectedReconciliationItem: any) => {
    console.log('selectedReconciliationItem', selectedReconciliationItem)
    if (selectedReconciliationItem?.Id > 0) {      
      await dispatch(reconciliationItems.resetAction({actionType:'update'}))
      await dispatch(reconciliationItems.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-items`, entity: 'reconciliationItems', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedReconciliationItem
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(reconciliationItems.resetAction({actionType:'update'}))
      await dispatch(reconciliationItems.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-items`, entity: 'reconciliationItems', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedReconciliationItem
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listReconciliationRequestItems();
  }

  const closeModal = () => {
    setShowReconciliationItemPopup(false)
  }

  useEffect(() => {
    console.log('listOfReconciliationItemsData', listOfReconciliationItemsData)
    // if(listOfReconciliationItemsData?.isSuccess){
      if(listOfReconciliationItemsData?.result?.items && listOfReconciliationItemsData?.result?.items?.length > 0)
      {
        console.log('listOfReconciliationItemsData?.result?.items[0].Error', listOfReconciliationItemsData?.result?.items[0].Error)
        if (listOfReconciliationItemsData?.result?.items[0].Error){
          setListItems(reconciliationData)          
        }   
        else {
          setListItems(listOfReconciliationItemsData?.result?.items)
        }     
      }  else {
        console.log('reconciliationData', reconciliationData)
        setListItems(reconciliationData)
      }    
    // }
  }, [listOfReconciliationItemsData]);

  useEffect(() => {
    console.log('list items', listItems)
  
  }, [listItems]);

  useEffect(() => {
    listReconciliationRequestItems();
  }, [deleteReconciliationsItemData]);

  useEffect(() => {
    createColumnDefs()
    listReconciliationRequestItems()
  }, [pageData, pageSize])

  return (
    <>
      {
        showReconciliationItemPopup ?
          <ReconciliationItemPopup
            selectedReconciliationItem={selectedReconciliationItem}
            closeModal={closeModal}
            handleSaveReconciliationItem={handleSaveReconciliationItem}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }

      {listOfReconciliationItemsData?.isLoading || 
      createReconciliationItemsData?.isLoading || 
      editReconciliationItemsData?.isLoading || 
      deleteReconciliationsItemData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfReconciliationItemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }} 
          headingName="Reconciliation Items" />
      }
    </>
  );
};

export default ReconciliationItems;


